jQuery(document).ready(function () {
  var cookie = false;
  var cookieContent = $(".cookie-disclaimer");

  checkCookie();

  if (cookie === false) {
    cookieContent.css("display", "flex");
  }

  if (cookie === true) {
    cookieContent.css("display", "none");
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    console.log(cname + "=" + cvalue + ";" + expires + ";path=/");
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    var user = getCookie("gdpr-cookie-consent");
    console.log(user);

    if (user !== "") {
      cookie = true;
      if (user === "accepted") {
        console.log("Consent given");
      }
    }
  }

  $(".accept-cookie").click(function () {
    setCookie("gdpr-cookie-consent", "accepted", 365);
    cookieContent.css("display", "none");
  });

  $(".decline-cookie").click(function () {
    setCookie("gdpr-cookie-consent", "declined", 365);
    cookieContent.css("display", "none");
  });
});
